(function () {
  'use strict';

  var section = document.querySelector('.neon-promo-bar-section');
  if (!section) return;

  var bar = section.querySelector('.neon-promo');
  if (!bar) return;

  var root = document.documentElement;

  /* ==========================================================================
     HOOGTE
     De header schuift hiermee naar beneden en de pagina-content krijgt er
     ruimte voor, dus deze waarde moet kloppen. De eerste meting gebeurt al
     inline in de sectie zelf, zodat de header niet zichtbaar verspringt.
     ========================================================================== */

  function setHeight() {
    root.style.setProperty('--neon-promo-h', bar.offsetHeight + 'px');
  }

  setHeight();
  window.addEventListener('resize', setHeight, { passive: true });

  if ('ResizeObserver' in window) {
    new ResizeObserver(setHeight).observe(bar);
  }

  /* ==========================================================================
     SCROLLGEDRAG
     Naar beneden: balk weg, header schuift op zijn plek.
     Omhoog: allebei terug.
     ========================================================================== */

  var lastY = window.pageYOffset;
  var ticking = false;
  var THRESHOLD = 8;  // kleine bewegingen negeren, anders flikkert het
  var START_AT = 80;  // bovenin altijd zichtbaar

  function onScroll() {
    var y = window.pageYOffset;
    var diff = y - lastY;

    if (Math.abs(diff) < THRESHOLD) {
      ticking = false;
      return;
    }

    if (diff > 0 && y > START_AT) {
      document.body.classList.add('neon-promo-hidden');
    } else if (diff < 0) {
      document.body.classList.remove('neon-promo-hidden');
    }

    lastY = y;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(onScroll);
  }, { passive: true });

  /* ==========================================================================
     COUNTDOWN
     ========================================================================== */

  var endAttr = bar.dataset.end;
  if (!endAttr) return;

  var end = Date.parse(endAttr);
  if (isNaN(end)) return;

  var num = {
    d: bar.querySelector('[data-cd="d"]'),
    h: bar.querySelector('[data-cd="h"]'),
    m: bar.querySelector('[data-cd="m"]'),
    s: bar.querySelector('[data-cd="s"]')
  };
  if (!num.d || !num.h || !num.m || !num.s) return;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  var timer = null;

  function tick() {
    var left = end - Date.now();

    if (left <= 0) {
      // Actie voorbij: balk weg en de ruimte eronder vrijgeven.
      // In de theme editor blijft hij staan, anders is hij niet te bewerken.
      clearInterval(timer);
      if (!bar.dataset.designMode) {
        section.hidden = true;
        root.style.setProperty('--neon-promo-h', '0px');
      }
      return;
    }

    var s = Math.floor(left / 1000);
    num.d.textContent = pad(Math.floor(s / 86400));
    num.h.textContent = pad(Math.floor((s % 86400) / 3600));
    num.m.textContent = pad(Math.floor((s % 3600) / 60));
    num.s.textContent = pad(s % 60);
  }

  tick();
  timer = setInterval(tick, 1000);
})();
